import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const reopenWorkItem = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('reopen', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyReopen')
		return null
	}
	try {
		const updated = await port.reopen(item.id, ctx.actorId, ctx.actorName)
		notify.success('workItem.reopened')
		return updated
	} catch {
		notify.error('workItem.reopenFailed')
		return null
	}
}

export { reopenWorkItem }
